module.exports = __webpack_public_path__ + "img/mathsentences.f5abe05c.png";